module.exports = "<p>\n  cxtpayment works!\n</p>\n"